import {useQuery, useQueryClient} from '@tanstack/react-query'
import {FleetService} from '../../../api/fleet-service'
import {Vehicle} from '@nxcr-org/web-api-interface/lib/fleet_service_pb'
import {NexusService} from 'global-apis/nexus-service'
import {useContext, useState} from 'react'
import {GetCustomerByIDResponse} from '@nxcr-org/web-api-interface/lib/customer_service_pb'
import { SnackbarContext, Snack } from 'shared/Snackbar'

export function useVehicleDetailsBlock({
  vehicle
}:{
  vehicle: Vehicle.AsObject
}) {
  const { setSnack} = useContext(SnackbarContext)
  const queryClient = useQueryClient()
  const [odometer, setOdometer] = useState('N/A')
  const [accountNumber, setAccountNumber] = useState('N/A')

  const onSuccessVehicleStateUpdate = () => {
    queryClient.invalidateQueries({queryKey: ['getVehicle', vehicle.id]})
    setSnack(new Snack({message: 'Successfully changed vehicle state', color:'success', open: true}))
  }

  const onErrorVehicleStateUpdate = (error: Error) => {
    setSnack(new Snack({message: `Error changing vehicle state: \n\n${error?.message}`, color:'error', open: true}))
  }

  useQuery({
    queryKey: ['telematics', vehicle.id],
    queryFn: async () => {
      let telematicsResponse
      try {
        telematicsResponse = await FleetService.getTelematics(vehicle.id)
      }
      catch (err) {
        console.error('getTelematics Error', err)
        return 'N/A'
      }
      if (!telematicsResponse) {
        setOdometer(telematicsResponse.telematicsList[0]?.odometer?.reading.toString())
      } else {
        return 'N/A'
      }

    },
      enabled: !!vehicle.id,
      placeholderData: 'N/A'
    }
  )

  useQuery({
    queryKey: ['customer', vehicle.customerId],
    queryFn: () => {
      return NexusService.getCustomerById(vehicle.customerId).catch((err) => {
        console.error('getCustomerById Error', err)
        return 'N/A'
      }).then(
        (response: GetCustomerByIDResponse.AsObject) => {
          if (response.customer) {
            setAccountNumber(response?.customer?.accountNumber || 'N/A')
          }
          return response || 'N/A'
        }
      )
    },
      enabled: !!vehicle.customerId && vehicle.customerId !== '00000000-0000-0000-0000-000000000000',
    }
  )

  return {
    odometer: odometer,
    accountNumber: accountNumber,
    onSuccessVehicleStateUpdate,
    onErrorVehicleStateUpdate,
  }
}
